<template>
  <div>
    <router-view :protocolData="protocolData" :clientData="clientData"  :client="clientData" :clientId="clientId"></router-view>
  </div>
</template>

<script>

  export default {
    name: 'CurrentStageLayout',

    props: {
      'protocolData': {
        type: Object,
        default: function () {
          return null
        }
      },
      'clientData': null,
      'protocolId': {
        type: [Number, String],
        default() {
          return null;
        },
      },
      'clientId': {
        type: [Number, String],
        default() {
          return null;
        },
      },
    },

    async created() {

    },
   

  };
</script>



// WEBPACK FOOTER //
// src/modules/dashboardParent/components/CurrentStageLayout.vue